angular.module('app.schedule.gameActions.gameActionsService', [])
  .factory('app.schedule.gameActions.gameActionsService', [
    '$http',
    function ($http) {
      "use strict";

      return {
        downloadGame: function (game, download) {
          let processResponse = function (data) {
            return new Promise((resolve, reject) => {
              if (data.error) {
                alert(data.error);
                reject({message: data.error});
              }
              else {
                let linkUrl = null;

                if (data.url) {
                  if (window.navigator.userAgent.match(/Firefox/) || window.navigator.userAgent.match(/Chrome/)) {
                    linkUrl = data.url;
                  } else {
                    let link = document.createElement('a');
                    link.href = data.url;
                    link.target = '_blank';

                    if (typeof link.download !== 'undefined') {
                      link.download = game.igameid + '.mp4';
                    }

                    if (document.createEvent) {
                      let e = document.createEvent('MouseEvents');
                      e.initEvent('click', true, true);
                      link.dispatchEvent(e);
                    }
                  }
                }

                if (data.download) {
                  download.status = data.download.status;
                }

                if (data.message) {
                  alert(data.message);
                }

                resolve(linkUrl);
              }
            });
          };

          return new Promise((resolve, reject) => {
            $http.get(window.location.api('games/' + game.igameid + '/download/' + download.audio_stream))
              .then(
                /**
                 * @param {HttpResponse} response
                 */
                function (response) {
                  processResponse(response.data)
                    .then(response => resolve(response))
                    .catch(response => reject(response));
                },
                /**
                 * @param {HttpResponse} response
                 */
                function (response) {
                  processResponse(response.data)
                    .then(response => resolve(response))
                    .catch(response => reject(response));
                }
              );
          });
        },
        updateGames: function (games) {
          // TODO Update games
          return $http.get(window.location.api('games?'))
        }
      }
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/schedule/gameActions/gameActionsService.js